import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { JSX } from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

import { Text } from 'Components/Text/Text';

import styles from './Tooltips.module.css';

export enum IconColor {
    GREEN = 'GREEN',
    YELLOW = 'YELLOW',
    RED = 'RED',
    WHITE = 'WHITE',
    GRAY = 'GRAY',
}

interface GenericTooltipProps {
    text: string;
    width?: number;
    height?: number;
    fontAwesomeIcon?: IconDefinition;
    iconColor?: IconColor;
    placement?: 'top' | 'bottom' | 'left' | 'right' | 'auto';
    title?: string;

    /** The element that triggers the tooltip on hover. If omitted, an icon is rendered as the trigger. **/
    children?: JSX.Element;
}

export const GenericTooltip = (props: GenericTooltipProps): JSX.Element => {
    const getIconColor = (): string => {
        switch (props.iconColor) {
            case IconColor.GREEN:
                return styles.tooltipColorGreen;
            case IconColor.YELLOW:
                return styles.tooltipColorYellow;
            case IconColor.WHITE:
                return styles.tooltipColorWhite;
            case IconColor.GRAY:
                return styles.tooltipColorGray;
            default:
                return styles.tooltipColorRed;
        }
    };

    const renderIcon = (): JSX.Element => {
        if (props.fontAwesomeIcon) {
            return (
                <span title={props.title} aria-label={props.title} role="img">
                    <FontAwesomeIcon icon={props.fontAwesomeIcon} className={getIconColor()} />
                </span>
            );
        } else {
            return <img src={'/i_toolTip.svg'} width={props.width || 15} height={props.height || 15} alt="tooltip" />;
        }
    };

    return (
        <OverlayTrigger
            placement={props.placement ?? 'right'}
            delay={{ show: 100, hide: 200 }}
            overlay={
                <Tooltip id="information">
                    <div className={styles.leftAlignedText}>
                        <Text color="white" noStyles={true}>
                            {props.text}
                        </Text>
                    </div>
                </Tooltip>
            }
        >
            {/* The <span> wrapper is needed because OverlayTrigger attaches a ref to its child, and not all components (e.g., IconButton) forward refs. */}
            {props.children ? <span>{props.children}</span> : renderIcon()}
        </OverlayTrigger>
    );
};
